(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("point-cloud-intensity", [], factory);
	else if(typeof exports === 'object')
		exports["point-cloud-intensity"] = factory();
	else
		root["point-cloud-intensity"] = factory();
})(self, function() {
return 